import React, { useEffect, useState, useRef } from "react";
import { toast } from "react-toastify";
import { Tabs, Card, Typography } from "antd";
import MainCard from '@/components/MainCard';
import BatchProcessApproval from "./BatchProcessApproval";
import BatchRecipeApproval from "./BatchRecipeApproval";
import RecipeViewApproval from "./RecipeViewApproval";
import InfoComponent from '@/components/Info';
import { accessControlUtils } from '@/components/AccessControlUtils';
import { useDispatch, useSelector } from "react-redux";
import ReusableSearchInput from '@/components/ReusableSearch';
import { useTranslation } from "react-i18next";
import { useTheme } from '@/App';
import { defaultColors } from '@/themes/antd-theme';
import Icons from '@/components/third-party/Icons';

const { Title } = Typography;

function Approvals() {
  const [user_access_data, set_user_access_data] = useState([]);

  useEffect(() => {
    try {
      const data = localStorage.getItem("user_access_data");
      if (data && data !== "undefined" && data !== "null") {
        set_user_access_data(JSON.parse(data));
      }
    } catch (error) {
      console.error("Error parsing user_access_data from localStorage:", error);
      localStorage.removeItem("user_access_data");
    }
  }, []);

  const [tab_value, set_tab_value] = useState("1");
  const selectedModule = useSelector((state) => state.moduleView) === "prod";
  const [searchvalue, setSearchvalue] = useState("");
  const { t } = useTranslation();
  const { isDark } = useTheme();

  // Dark mode colors
  const textColor = isDark ? '#ffffff' : '#1f2937';

  return (
    <Card
    className="m-2.5 border border-gray-300 shadow-md"
      title={
        <div className="flex items-center gap-2">
          <Icons.CheckCircle className="text-blue-600" size={24} />
          <Title
            level={4}
            style={{
              color: textColor,
              margin: 0,
              padding: 0,
            }}
          >
            {t('BMR Approvals')}
          </Title>
        </div>
      }
      extra={
        <ReusableSearchInput
          placeholder="Search here..."
          width={250}
          onSearch={(value) => setSearchvalue(value)}
          onChange={(e) => setSearchvalue(e.target.value)}
        />
      }
    >
      <Tabs
        onChange={(key) => {
          set_tab_value(key);
        }}
        tabBarExtraContent={
          <div className="flex gap-1">
            <InfoComponent
              infoShow={true}
              infoText={`view ${selectedModule ? "MBMR" : "MBPR"}}`}
            />
          </div>
        }
        items={[
          ...(accessControlUtils("BMR Approval")?.read_access
            ? [
                {
                  key: "1",
                  label: `View ${selectedModule ? "BMR" : "BPR"}`,
                  children: <RecipeViewApproval searchvalue={searchvalue} />,
                },
              ]
            : []),
          ...(accessControlUtils("BMR Approval")?.update_access
            ? [
                {
                  key: "2",
                  label: `${selectedModule ? "BMR" : "BPR"} Process Approval`,
                  children: <BatchProcessApproval searchvalue={searchvalue} />,
                },
              ]
            : []),
          ...(accessControlUtils("BMR Approval")?.update_access
            ? [
                {
                  key: "3",
                  label: `${selectedModule ? "BMR" : "BPR"} Approval`,
                  children: <BatchRecipeApproval searchvalue={searchvalue} />,
                },
              ]
            : []),
        ]}
      />
    </Card>
  );
}

export default Approvals;
